"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const locales_1 = __importDefault(require("./locales"));
const getLogoFromCache = (src) => {
    if (typeof window !== 'undefined') {
        const image = new Image();
        image.src = src;
        return image.complete ? image : null;
    }
    return null;
};
const CompanyLogo = ({ src }) => (react_2.default.createElement(react_1.Image, { alt: locales_1.default.alt, height: "56px", 
    // don't display the loader if the image is already cached
    ignoreFallback: Boolean(getLogoFromCache(src)), maxWidth: "120px", objectFit: "contain", src: src }));
exports.default = CompanyLogo;
